<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"基本信息"
					]
				},
				{
					"type": "input",
					"field": "acc_code",
					"title": "账户编码",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "acc_name",
					"title": "账户名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$company",
					"field": "companyid",
					"title": "业务公司",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "bank",
					"title": "开户行",
					"value": null,
					"hidden": false,
					"props": {
						"readonly": false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "accountbusiness",
					"title": "业务类型",
					"value": null,
					"hidden": false,
					"props": {
						"name": "accountbusiness"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "accountuses",
					"title": "账户用途",
					"value": null,
					"hidden": false,
					"props": {
						"name": "accountuses"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "bankname",
					"title": "银行",
					"value": null,
					"hidden": false,
					"props": {
						"name": "bankname"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "targetdepartment",
					"title": "部门",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "plant",
					"title": "平台",
					"value": [],
					"hidden": false,
					"options": [{
						"value": "wln",
						"label": "万里牛",
					},{
						"value": "cz",
						"label": "财资",
					},{
						"value": "jindie",
						"label": "金蝶",
					}],
					"props": {
						"emptyoption":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$switchs",
					"field": "dailyenable",
					"title": "日对账",
					"value": 1,
					"hidden": false,
					"props": {
						"name": ""
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"合同业务 (电子合同专用账户)"
					]
				},
				{
					"type": "$select",
					"field": "contract",
					"title": "业务类型",
					"value": [],
					"hidden": false,
					"options": [{
						"value": "sale",
						"label": "销售",
					}],
					"props": {
						"emptyoption":false,
						"checkbox":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"专用项 (对应模块专用账户)"
					]
				},
				{
					"type": "$select",
					"field": "special",
					"title": "专用业务",
					"value": [],
					"hidden": false,
					"options": [{
						"value": "supplier",
						"label": "供应商",
					}],
					"props": {
						"emptyoption":false,
						"checkbox":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"备用金 (备用金模块可展示账户)"
					]
				},
				{
					"type": "$select",
					"field": "imprest",
					"title": "业务类型",
					"value": [],
					"hidden": false,
					"options": [{
						"value": "purchase",
						"label": "采购",
					},{
						"value": "administration",
						"label": "行政",
					},{
						"value": "exchange",
						"label": "售后",
					}],
					"props": {
						"emptyoption":false,
						"checkbox":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"收支配置"
					]
				},				
				{
					"type": "$emun",
					"field": "suppliersettlementtype",
					"title": "结算类型",
					"value": null,
					"hidden": false,
					"props": {
						"name": "suppliersettlementtype"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "cdsign",
					"title": "收支",
					"value": null,
					"hidden": false,
					"options": [{
						"value": "全部",
						"label": "全部",
					}, {
						"value": "收",
						"label": "收",
					}, {
						"value": "支",
						"label": "支",
					}],
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "paymin",
					"title": "最小支付金额",
					"value": null,
					"hidden": false,
					"props": {
						"precision": 2
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "paymax",
					"title": "最大支付金额",
					"value": null,
					"hidden": false,
					"props": {
						"precision": 2
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "collectioninvoice",
					"title": "收款单开票",
					"value": null,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "exchangepayaccount",
					"title": "售后默认付款账户",
					"value": null,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "qrcode",
					"title": "收款码账户编码",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"其他"
					]
				},
				{
					"type": "$input",
					"field": "mchntNo",
					"title": "银联商户号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "noinvoiceacc",
					"title": "无发票专用",
					"value": null,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"线下收款 (线下收款二维码)"
					]
				},
				{
					"type": "$switchs",
					"field": "underlineenable",
					"title": "线下收款",
					"value": 0,
					"hidden": false,
					"props": {
						"name": ""
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$upload",
					"field": "underlinecode",
					"title": "线下收款码",
					"value": null,
					"hidden": false,
					"props": {
						"name": "",
						"limit":1
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "120px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 12,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			currentrow: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '账号配置',
				modal_width: 800,
				modal_height: 600,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.sourceData = JSON.parse(JSON.stringify(this.currentrow))
				
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			setFormData() {
				if (this.sourceData) {
					this.sourceData.underlinecode = this.sourceData.underlinecode?JSON.parse(this.sourceData.underlinecode):null
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					// submitData.underlinecode = submitData.underlinecode?JSON.parse(submitData.underlinecode):null
					this.submitDataFormater(submitData)
					this.$api.bankaccount.update(this.currentrow.id, submitData).then(() => {
						this.$emit('success')
						this.modal_cancel()
					})
					console.log(submitData)
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>